import React, { useCallback, useContext, useEffect, useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  invoiceDeleteAction,
  returnBillTableAction,
  storeDetailsAction,
  returnBillViewAction,
} from "../../redux/actions/invoices-action";
import LoadingSpinner from "../../components/helper-components/loading-spinner";
import moment from "moment";
import InvoiceFilter from "../../components/tables/table-filter/invoice-filter";
import { DataContext } from "../../components/layouts/main-layout";
import { handlea4Print } from "../../components/helper-components/helper-function";
import { useHotkeys } from "react-hotkeys-hook";
import { handleReturnBillPrint } from "../../components/return-bill/invoice-thermal-printer";
import DynamicTransactionTable from "../../components/tables/dynamic-transaction-table";
import BadgesComponent from "../../components/tables/badges-component";
import { TimerIcon } from "lucide-react";
import ReturnIcon from "../../assets/icons/billing-container-icons/return-icon";
import CashIcon from "../../assets/icons/pay-method-icons/cash-icon";
import TransSummaryComp from "../../components/helper-components/trans-summary-comp";

const ReturnBillTable = () => {
  const [heading, setHeading] = useState([]);
  const [billSummary, setBillSummary] = useState({});
  const { permissionFn } = useContext(DataContext);
  const [storeDetails, setStoreDetails] = useState({});
  const dispatch = useDispatch();
  const [reload, setReload] = useState(false);
  const [orders, setOrders] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [filterData, setFilterData] = useState({
    sort_by: "",
    sort_order: "",
    // selectColumn: "icn_invoice_number",
    selectColumn: "",
    from: "",
    to: "",
    inputValue: "",
    order_status: "",
    payment_status: "",
  });

  useEffect(() => {
    dispatch(storeDetailsAction(onSuccessStoreDetails, onErrorStoreDetails));
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const returnBillData = parsed.find((obj) => obj?.bill_return_list);
      if (returnBillData?.bill_return_list) {
        setHeading(returnBillData.bill_return_list);
      }
    }
  }, []);

  const onSuccessStoreDetails = (data) => {
    setStoreDetails(data?.data);
  };
  const onErrorStoreDetails = () => {};

  useEffect(() => {
    dispatch(
      returnBillTableAction(
        {
          pageNumber: currentPage,
          pageSize: pageSize,
          filterData,
        },
        onSuccess,
        onError
      )
    );
  }, [currentPage, pageSize, filterData, reload, dispatch]);
  const onSuccess = (data) => {
    setError(false);
    setLoading(false);
    setOrders(data?.data?.orderList ?? []);
    setDataCount(data?.data?.totalCount);
    setBillSummary(data?.data?.returnStats);
  };
  const onError = (data) => {
    setError(true);
    setLoading(false);
  };

  const navigate = useNavigate();

  const tableBodyData = orders?.map((item) => {
    return {
      id: item?.icn_id,
      icn_invoice_number:
        <span className={`cursor-`}>{item?.icn_invoice_number ?? "--"}</span> ??
        "--",
      cmr_phone_number: item?.cmr_phone_number,
      cmr_first_name: item?.cmr_first_name ?? "",
      order_status: (
        <BadgesComponent
          status={item?.is_draft_order ? "draft" : "completed"}
        />
      ),

      icn_payment_status: <BadgesComponent status={item?.icn_payment_status} />,
      update_date: moment(item?.update_date).format("MMM D, YYYY"),
      icn_total_amount: "₹ " + item?.icn_total_amount,
      icn_order_status: item?.is_draft_order ? "draft" : "open",
      icn_custom_invoice_number: item?.icn_custom_invoice_number ?? "--",
      created_date: item?.created_date
        ? moment(item?.created_date).format("DD MMM YYYY")
        : "--",
      update_date: item?.update_date
        ? moment(item?.update_date).format("DD MMM YYYY")
        : "--",
      created_user_name: item?.created_user_name ?? "--",
      updated_user_name: item?.updated_user_name ?? "--",
      store_code: item?.store_code ?? "--",
      store_name: item?.store_name ?? "--",
      store_type: item?.store_type ?? "--",
      firm_name: item?.firm_name ?? "--",
      cmr_code: item?.cmr_code ?? "--",
    };
  });
  const paginationProps = {
    pageSize: pageSize,
    setPageSize: setPageSize,
    dataCount: dataCount,
    setCurrentPage: setCurrentPage,
    currentPage: currentPage,
  };
  const handleFilterClick = useCallback(() => {
    setShowFilter((prevShowFilter) => !prevShowFilter);
  }, []);

  const filterby = showFilter ? (
    <InvoiceFilter
      setCurrentPage={setCurrentPage}
      filterData={filterData}
      setFilterData={setFilterData}
    />
  ) : null;

  const handleVoidAction = (id) => {
    setLoading(true);
    dispatch(
      invoiceDeleteAction(
        {
          icn_id: id,
        },
        onSuccessDel,
        onErrorDel
      )
    );
  };

  const onSuccessDel = () => {
    setReload(!reload);
    setLoading(false);
  };
  const onErrorDel = () => {};

  useHotkeys("escape", () => {
    setShowFilter(false);
  });

  function viewFn(id) {
    dispatch(returnBillViewAction(id, onSuccessView, onErrorView));
  }
  const onSuccessView = (data) => {
    let invoice = data?.data?.[0];
    handleReturnBillPrint(
      {
        items: invoice?.itemData,
        orderData: [invoice?.orderData],
      },
      storeDetails
    );
  };
  const onErrorView = (data) => {};

  const TransactionSummary = [
    {
      conClass:
        "bg-[var(--trans-stats-con-green-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Total Return Bills",
      value: billSummary?.totalReturnBills,
      icon: <ReturnIcon fill="var(--trans-stats-con-green-fg)" />,
      // icon: <RupeesIcon />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-orange-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Return Amount",
      value: billSummary?.totalReturnAmount,
      icon: <ReturnIcon fill="var(--trans-stats-con-orange-fg)" />,
      // icon: <TimerIconBg />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-red-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Return Items  ",
      value: billSummary?.uniqueReturnItems,
      icon: <ReturnIcon fill="var(--trans-stats-con-red-fg)" />,

      // icon: <ReturnIcon />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-blue-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Return Quantity",
      value: billSummary?.totalReturnQuantity,
      icon: <ReturnIcon fill="var(--trans-stats-con-blue-fg)" />,

      // icon: <AvgSaleIcon />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
  ];
  const paymentMethods = [
    {
      conClass: "bg-[var(--trans-stats-con-sales-bg)] ",
      label: "Cash",
      value: billSummary?.cash_amount,
      // desc: billSummary?.cash_percentage,
      icon: <CashIcon />,
      iconConClass: "bg-[var(--list-payMet-cash-bg)]",
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },

    {
      conClass: "bg-[var(--trans-stats-con-sales-bg)]",
      label: "Credit",
      value: billSummary?.credit_amount,
      // desc: billSummary?.credit_percentage,
      icon: <TimerIcon />,
      iconConClass: "bg-[var(--list-payMet-credit-bg)]",
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
  ];

  const summaryArray =
    TransactionSummary?.length > 0 ? (
      <div className="px-[24px] pt-[16px] flex gap-5">
        {TransactionSummary?.map((sum) => (
          <TransSummaryComp sum={sum} />
        ))}
      </div>
    ) : (
      <></>
    );

  const paymentArray =
    paymentMethods?.length > 0 ? (
      <div className="px-[24px] pt-[16px]">
        <div className="border-radius   h-[5rem] w-[100%] p-3 flex justify-around bg-[var(--trans-stats-con-Sblue-bg)]">
          {paymentMethods?.map((pay) => (
            <div className="flex gap-3 items-center w-[50%]">
              <div className={`p-2 rounded-[12px] ${pay?.iconConClass}`}>
                {pay?.icon}
              </div>
              <div className="flex flex-col gap-2">
                <span className="text-[length:var(--bill-list-payMet-lab-fs)] font-[var(--bill-list-payMet-lab-fw)] text-[var(--bill-list-payMet-lab-fg)]">
                  {pay?.label}
                </span>
                <div className="flex gap-2 items-center">
                  <span className="text-[length:var(--bill-list-payMet-val-fs)] font-[var(--bill-list-payMet-val-fw)] text-[var(--bill-list-payMet-val-fg)]">
                    ₹{pay?.value || 0}
                  </span>{" "}
                  {/* <span className="text-[length:var(--bill-list-payMet-desc-fs)] font-[var(--bill-list-payMet-desc-fw)] text-[var(--bill-list-payMet-desc-fg)]">
                    ({pay?.desc ?? 0} %)
                  </span> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    ) : (
      <></>
    );

  return (
    <InnerLayout
      permissionFn={permissionFn}
      module="invoice"
      list={true}
      title="Return Bill"
    >
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <></>
      ) : (
        <>
          <DynamicTransactionTable
            summaryArray={summaryArray}
            paymentArray={paymentArray}
            path="return-bill"
            menu={true}
            transactionKey="icn"
            is_checkbox_req={false}
            invoicePrntFn={(id) => {
              handlea4Print(id, "invoice_credit_note", dispatch);
            }}
            newBtnTxt="New Bill"
            onClickItemFn={(id) => navigate(`/view-return-bill/${id}`)}
            list={false}
            permissionFn={permissionFn}
            module="invoice"
            transaction="Returned Bill"
            type="invoice_credit_note"
            voidFn={handleVoidAction}
            showFilter={showFilter}
            filterFn={handleFilterClick}
            setFilterData={setFilterData}
            filterData={filterData}
            paginationProps={paginationProps}
            tableHeading={heading}
            tableBodyData={tableBodyData}
            placeholder="Search"
            filterBy={filterby}
            transaction_type="invoice_credit_note"
            extraFilters={[
              { label: "Item Code", value: "item_code", column: true },
              { label: "Item Name", value: "item_name", column: true },
              { label: "Custom Invoice Number", value: "icn_custom_invoice_number", column: true }
            ]}
            initialFilter={{
              sort_by: "",
              sort_order: "",
              selectColumn: "icn_invoice_number",
              from: "",
              to: "",
              inputValue: "",
              order_status: "",
              payment_status: "",
            }}
          />
        </>
      )}
    </InnerLayout>
  );
};

export default ReturnBillTable;
const tableHeading = [
  {
    label: "RETURN BILL NUMBER",
    value: "icn_invoice_number",
    display: true,
    column: true,
  },
  {
    label: "PHONE NUMBER",
    value: "cmr_phone_number",
    display: true,
    column: true,
  },
  {
    label: "CUSTOMER NAME",
    value: "cmr_first_name",
    display: true,
    column: true,
  },
  {
    label: "ORDER STATUS",
    value: "order_status",
    display: false,
    column: false,
  },
  {
    label: "PAYMENT STATUS",
    value: "icn_payment_status",
    display: false,
    column: false,
  },
  {
    label: "DATE",
    value: "update_date",
    display: true,
    column: false,
  },

  {
    label: <span className="flex justify-end">AMOUNT</span>,
    value: "icn_total_amount",
    display: true,
    column: false,
    className: "justify-end pe-5",
  },
  {
    label: "",
    value: "",
    column: false,
  },
  // {
  //   label: "",
  //   value: "",
  //   column: false,
  // },
];
